var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "view-all-work-permits" } },
    [
      _c("sticky", [
        _c("div", { staticClass: "clearfix header-panel" }, [
          _c("div", { staticClass: "header" }, [
            _c("span", { staticClass: "notice-header" }, [
              _vm._v("\n          " + _vm._s(_vm.title) + "\n        "),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "right-btns" },
            [
              !_vm.isHoistingAtLocationPage
                ? [
                    _vm.showHoistingModule
                      ? _c(
                          "a",
                          {
                            staticClass: "name-hyper-link quick-search-link",
                            on: {
                              click: function ($event) {
                                return _vm.quickSearch(true, false, true)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.threeDaysHoistingLabel) +
                                "\n          "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "name-hyper-link quick-search-link",
                        on: {
                          click: function ($event) {
                            return _vm.quickSearch(true)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("workPermit.todayPermits")) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "name-hyper-link quick-search-link",
                        on: {
                          click: function ($event) {
                            return _vm.quickSearch(false, true)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("workPermit.nonApprPermits")) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn--darkblue",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.resetFilters()
                    },
                  },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("action.resetFilter")) +
                      "\n        "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn--orange",
                  attrs: { id: "query-btn", type: "button", disabled: false },
                  on: {
                    click: function ($event) {
                      return _vm.search()
                    },
                  },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("action.search")) +
                      "\n        "
                  ),
                ]
              ),
            ],
            2
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "work-premits-view-all-table" },
        [
          _c(
            "div",
            {
              staticStyle: {
                display: "inline",
                "vertical-align": "middle",
                "margin-left": "15px",
              },
            },
            [
              _c("span", [
                _vm._v(
                  _vm._s(_vm.$t("total")) +
                    ": " +
                    _vm._s(_vm.sortedItems.length)
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("CommonTable", {
            ref: "commonTable",
            attrs: {
              renderHeaderList: _vm.itemHeaders,
              tableId: _vm.tableId,
              minWidth1800px: false,
              needSearch: true,
              yScrollAuto: true,
              tableContentLists: _vm.sortedItems,
              defaultOrder: true,
              defaultOrderKey: "duration",
              interactionFunc: _vm.interactionFunc,
              getConditions: _vm.getConditions,
              defaultConditions: _vm.commonTableSearch,
              enterEvent: _vm.search,
              needSaveTableInfo: _vm.needSaveTableInfo,
              orderMethods: _vm.orderMethods,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "HKLRemindModal",
        { ref: "remindEmptyModal" },
        [
          _c("template", { slot: "title" }, [
            _vm._v("\n      " + _vm._s(_vm.$t("hint.emptySearch")) + "\n    "),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }